import React from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Redirect, Switch, useHistory} from 'react-router-dom'
import Home from '../Pages/Public/Home/Home';
import Members from '../Pages/Public/Members/Members';
import B2Top from './B2Top/B2Top';
import Support from '../Pages/Public/Support/Support';
import MemberTutorials from '../Pages/Public/MemberTutorials/MemberTutorials'
import Business from '../Pages/Public/Business/Business'
import BusinessTutorials from '../Pages/Public/BusinessTutorials/BusinessTutorials';
import Blogs from '../Pages/Public/Blogs/Blogs'
import PageNotFound from './404/PageNotFound'
import Registration from "../Pages/Identity/Registration/Registration";
import Login from "../Pages/Identity/Login/Login";
import ForgotPassword from "../Pages/Identity/ForgotPassword/ForgotPassword";
import AddEvent from "../Pages/Member/AddEvent/AddEvent";
import VerifyOtp from "../Pages/Identity/VerifyOtp/VerifyOtp";
import Profile from "../Pages/Identity/Profile/Profile";
import {isLoggedIn} from "../Api/Utils/apiUtils";
import ChangePassword from "../Pages/Identity/ChangePassword/ChangePassword";
import ManageEvents from "../Pages/Member/ManageEvents/ManageEvents";
import EventsDetails from "../Pages/Member/EventsDetails/EventsDetails";
import AddProduct from "../Pages/Business/AddProduct/AddProduct";
import ManageProducts from "../Pages/Business/ManageProducts/ManageProducts";
import UpdateProduct from "../Pages/Business/UpdateProduct/UpdateProduct";
import ManageBusiness from "../Pages/Business/ManageBusiness/ManageBusiness";
import ManageOrder from '../Pages/Business/ManageOrder/ManageOrder';
import ManagePayment from '../Pages/Business/ManagePayment/ManagePayment';
import FavouriteSupplier from '../Pages/Member/FavouriteSupplier/FavouriteSupplier';
import Supplier from '../Pages/Member/Supplier/Supplier';
import Message from '../Pages/Business/Message/Message';
import BusinessProfile from '../Pages/Identity/BusinessProfile/BusinessProfile';
import ManageMemberPayment from '../Pages/Member/ManageMemberPayment/ManageMemberPayment';
import SingleBlog from '../Pages/Public/Blogs/SingleBlog/SingleBlog';
import SingleSupplier from '../Pages/Member/SingleSupplier/SingleSupplier';
import SingleProduct from '../Pages/Member/SingleProduct/SingleProduct';
import GuestList from '../Pages/Member/GuestList/GuestList';
import TodoList from '../Pages/Member/TodoList/TodoList';
import ManageBudget from '../Pages/Member/ManageBudget/ManageBudget';
import PrivacyPolicy from '../Pages/Public/PrivacyPolicy/PrivacyPolicy';
import TermsAndCondition from '../Pages/Public/TermsAndCondition/TermsAndCondition';
import Contest from '../Pages/Public/Contest/Contest';
import ContestTerms from '../Pages/Public/ContestTerms/ContestTerms'

const App = () => {
  return (
    /* ===
    There some component have <a></a> tag those a tag used for external link if you want replace with internal link then top of the component add this "import { Link } from 'react-router-dom';" then replace "a" tag with "Link" replace "href" attribut with "to"
    === */
    <Router>
      <div className="App">
        <Switch >
          <Route path="/" exact component={Home} />
          <Route path="/members" exact component={Members} />
          <Route path="/support" exact component={Support} />
          <Route path="/member-app-tutorials" exact component={MemberTutorials} />
          <Route path="/business" exact component={Business} />
          <Route path="/running-contest/:token" exact component={Contest} /> 
          <Route path="/contest-trems" exact component={ContestTerms} />
          <Route path="/business-app-tutorials" exact component={BusinessTutorials} />
          <Route path="/blog" exact component={Blogs} />
          <Route path="/privacy-policy" exact component={PrivacyPolicy} />
          <Route path="/terms-and-conditions" exact component={TermsAndCondition} />
          <Route path="/blog/:url" exact component={SingleBlog} />

          <UnauthAuthedRoute path="/login" exact component={Login}  />
          <UnauthAuthedRoute path="/register" exact component={Registration} />
          <UnauthAuthedRoute path="/forgot-password" exact component={ForgotPassword} />
          <UnauthAuthedRoute path="/verify-otp" exact component={VerifyOtp} />

          <AuthRoute path="/profile" exact component={Profile} />
          <AuthRoute path="/change-password" exact component={ChangePassword} />

          <AuthRoute path="/add-event" exact component={AddEvent} />
          <AuthRoute path="/:eventid/guest-list" exact component={GuestList} />
          <AuthRoute path="/:eventid/to-do" exact component={TodoList} />
          <AuthRoute path="/:eventid/manage-budget" exact component={ManageBudget} />
          <AuthRoute path="/favourite-suppliers" exact component={FavouriteSupplier} />
          <AuthRoute path="/manage-events" exact component={ManageEvents} />
          <AuthRoute path="/suppliers" exact component={Supplier} />
          <AuthRoute path="/event-details/:eventId" exact component={EventsDetails} />
          <AuthRoute path="/suppliers/:supplierID" exact component={SingleSupplier} />
          <AuthRoute path="/suppliers/:supplierID/:productID" exact component={SingleProduct} />
          <AuthRoute path="/messages" exact component={Message} />
          <AuthRoute path="/manage-payments" exact component={ManageMemberPayment} />

          <AuthRoute path="/business-profile" exact component={BusinessProfile} />
          <AuthRoute path="/add-product" exact component={AddProduct} />
          <AuthRoute path="/manage-products" exact component={ManageProducts}/>
          <AuthRoute path="/product-details/:productId" exact component={UpdateProduct} />
          <AuthRoute path="/manage-business" exact component={ManageBusiness} />
          <AuthRoute path="/manage-orders" exact component={ManageOrder} />
          <AuthRoute path="/manage-payment-method" exact component={ManagePayment} />

          <Route path="/*" component={PageNotFound} />
        </Switch>
        <B2Top />
      </div>
    </Router>

  );
}


function AuthRoute ({ component:Component, ...rest }) {
  const isAuthenticated = isLoggedIn();
  return (
      <Route
          {...rest}
          render={({ location }) =>
              isAuthenticated ? (
                  <Component/>
              ) : (
                  <Redirect
                      to={{
                        pathname: "/login",
                        state: { from: location }
                      }}
                  />
              )
          }
      />
  );
}

function UnauthAuthedRoute ({ component:Component, ...rest }) {
  const isAuthenticated = isLoggedIn();
  const history = useHistory();
  if(isAuthenticated){
    history.push("/profile");
  }
  return (
      <Route {...rest} render={() => <Component/>}/>
  );
}
export default App;
